export enum PlanAction {
  None = 'None',
  Upgrade = 'Upgrade',
  ContactUs = 'Contact_us'
}

export enum BillingFrequency {
  Monthly = 'month',
  Annually = 'year',
  Custom = 'custom'
}

export enum BillableFeature {
  SpaceDuration = 'SpaceDuration',
  CloudRecordingDuration = 'CloudRecordingDuration',
  WebViewerDuration = 'WebViewerDuration'
}

export enum BillingStrategy {
  USAGE_BASED = 'USAGE_BASED',
  SEAT_BASED = 'SEAT_BASED',
  CUSTOM_BASED = 'CUSTOM_BASED'
}

export enum BillingType {
  Automatic = 'Automatic',
  Manual = 'Manual'
}

export enum BillingVersion {
  V1 = 'v1',
  V2 = 'v2'
}
